import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const nativeSelectSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.nativeSelect, {
        base: {
            field: {
                borderRadius: 'lg',
                borderWidth: '1px',
                // _focusVisible: {
                //     outlineWidth: 0,
                //     boxShadow: 'none',
                // },
                '& > option, & > optgroup': {
                    color: 'gray.950',
                },
            },
        },
        variants: {
            size: {
                md: {
                    field: {
                        fontSize: 'md',
                        h: '2.875rem',
                    },
                },
            },
        },
    }),
);
